<template>
  <div>
    <!-- <p class="c-inner-title">人群包管理</p> -->
    <div class="auto">
      <page-title title="人群包管理" icon="fa-wechat"></page-title>
    </div>
    <el-row class="box-row m-t-15">
      <el-col class="box-col" :span="24">
        <div class="table-wrap">
          <el-row class="table-control">
            <el-col :span="12">
              <el-button type="primary" @click="addHandle" class="el-icon-plus" size="small"> 添加人群包</el-button>
              <el-button @click="uploadPackageHandle" class="el-icon-plus" size="small"> 上传人群包</el-button>
            </el-col>
            <el-col :span="12" class="flex-box j-c-e">
              <el-input v-model="filter.search" size="small" clearable class="m-lr-5" style="width:200px;" placeholder="搜索名称"><i class="el-icon-search el-input__icon" slot="suffix"></i></el-input>
              <el-button type="primary" size="small" @click="handleChangeFilter()">搜索</el-button>
            </el-col>
          </el-row>
          <el-table
            :data="tableData"
            style="width: 100%" v-loading="loading" size="small">
            <el-table-column prop="id" width="120" label="id"></el-table-column>
            <el-table-column prop="name" label="名称"></el-table-column>
            <el-table-column prop="remark" label="备注"></el-table-column>
            <el-table-column prop="status_name" label="状态"></el-table-column>
            <el-table-column prop="total" label="人数"></el-table-column>
            <el-table-column prop="ctime" label="创建时间" width="160"></el-table-column>
            <el-table-column label="操作" width="150">
              <template slot-scope="scope">
                <el-button
                  @click="previewHandle(scope.row)"
                  type="primary"
                  size="small">
                  查看
                </el-button>
                <!-- <el-button
                  @click="deleteHandle(scope.row)"
                  type="primary"
                  size="small">
                  删除
                </el-button> -->
              </template>
            </el-table-column>
          </el-table>
          <div v-if="total > filter.limit" class="main-page m-t-10 p-none">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="Number(filter.page)"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="Number(filter.limit)"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total">
            </el-pagination>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog title="添加人群包" :modal-append-to-body="false" :close-on-press-escape="false" fullscreen :visible.sync="dialogVisible" @close="handleExit">
      <el-form ref="refForm" :rules="rules" :model="form" label-width="80px" size="small" v-loading="addLoading">
        <el-form-item prop="name" label="名称">
          <el-input v-model.trim="form.name"></el-input>
        </el-form-item>
        <el-form-item prop="filter" label="筛选条件">
          <el-button @click="addFilter" class="el-icon-plus" size="mini">添加筛选条件</el-button>
          <div class="m-t-10 flex-box">
            <div v-for="(item, index) in chooseFilters" :key="index" class="filter-box" :style="index === 0 ? ('width:calc(' + 100/chooseFilters.length + '% - 70px);float:left;flex:none;max-width:500px;') : 'max-width:600px;'">
              <user-filter-show :chooseFilters="chooseFilters" :chooseIndex="index" :filters="filters" @editFilter="editFilter" @deleteFilter="deleteFilter" @changeRelation="changeRelation"></user-filter-show>
              <!-- <user-filter-show :chooseFilters="chooseFilters" :chooseIndex="index" :filters="filters"></user-filter-show> -->
            </div>
          </div>
        </el-form-item>
        <el-form-item prop="remark" label="备注">
          <el-input v-model.trim="form.remark"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSubmit">提交</el-button>
          <el-button @click="handleExit">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog title="添加条件" :modal-append-to-body="false" :close-on-press-escape="false" width="1200px" :visible.sync="filterVisible">
      <div v-loading="filterLoading">
        <user-filters :filters="filters" :allReadyChoose="chooseFilters[currentIndex]" :chooseValDemo="chooseValStr" @close="closeFilters" @getValues="getFilterValues"></user-filters>
      </div>
    </el-dialog>
    <el-dialog title="上传人群包" :modal-append-to-body="false" :close-on-press-escape="false" :visible.sync="uploadVisible" @close="uploadHandleExit">
      <el-form ref="refUploadForm" :rules="uploadRules" :model="uploadForm" label-width="110px" size="small" v-loading="addLoading">
        <el-form-item prop="name" label="名称">
          <el-input v-model.trim="uploadForm.name"></el-input>
        </el-form-item>
        <el-form-item prop="type" label="上传类型">
          <el-radio v-model="uploadForm.filter_type" label="openid_list">openid</el-radio>
          <el-radio v-model="uploadForm.filter_type" label="openid_file">openid文件</el-radio>
          <el-radio v-model="uploadForm.filter_type" label="unionid_list">unionid</el-radio>
          <el-radio v-model="uploadForm.filter_type" label="unionid_file">unionid文件</el-radio>
        </el-form-item>
        <el-form-item prop="openid_list" label="openid" v-if="uploadForm.filter_type === 'openid_list'">
          <el-input type="textarea" :rows="4" placeholder="请输入内容" v-model="uploadForm.openid_list"></el-input>
          <p class="font12 grey888">tips:每行一个openid</p>
        </el-form-item>
        <el-form-item prop="unionid_list" label="unionid" v-if="uploadForm.filter_type === 'unionid_list'">
          <el-input type="textarea" :rows="4" placeholder="请输入内容" v-model="uploadForm.unionid_list"></el-input>
          <p class="font12 grey888">tips:每行一个unionid</p>
        </el-form-item>
        <el-form-item prop="openid_file" label="openid文件" v-if="uploadForm.filter_type === 'openid_file'">
          <el-upload
            class="upload-demo"
            :data="uploadData"
            :action="config.root + '/mp/material/uploadMaterial'"
            :on-success="handleAvatarSuccess"
            :on-error="uploadError"
            :before-upload="beforeAvatarUpload"
            :show-file-list="false">
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">只能上传txt文件</div>
          </el-upload>
          <div>{{uploadForm.openid_file}}</div>
        </el-form-item>
        <el-form-item prop="unionid_file" label="unionid文件" v-if="uploadForm.filter_type === 'unionid_file'">
          <el-upload
            class="upload-demo"
            :data="uploadData"
            :action="config.root + '/mp/material/uploadMaterial'"
            :on-success="handleAvatarSuccess"
            :on-error="uploadError"
            :before-upload="beforeAvatarUpload"
            :show-file-list="false">
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">只能上传txt文件</div>
          </el-upload>
          <div>{{uploadForm.unionid_file}}</div>
        </el-form-item>
        <el-form-item prop="remark" label="备注">
          <el-input v-model.trim="uploadForm.remark"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="uploadHandleSubmit('refUploadForm')">提交</el-button>
          <el-button @click="uploadHandleExit">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog title="查看人群包" :modal-append-to-body="false" :fullscreen="previewForm.filter_type === 'query'" :close-on-press-escape="false" :visible.sync="previewVisible">
      <el-form :model="previewForm" label-width="100px" size="small" v-loading="previewLoading">
        <el-form-item prop="name" label="名称">
          <el-input v-model.trim="previewForm.name" disabled></el-input>
        </el-form-item>
        <el-form-item prop="type" label="上传类型" v-if="previewForm.filter_type !== 'query'">
          <span v-if="previewForm.filter_type === 'openid_list'">openid</span>
          <span v-if="previewForm.filter_type === 'openid_file'">openid文件</span>
          <span v-if="previewForm.filter_type === 'unionid_list'">unionid</span>
          <span v-if="previewForm.filter_type === 'unionid_file'">unionid文件</span>
        </el-form-item>
        <el-form-item prop="openid_list" label="openid" v-if="previewForm.filter_type === 'openid_list' && previewForm.filter_type !== 'query'">
          <el-input type="textarea" :rows="4" placeholder="请输入内容" v-model="previewForm.user_list" disabled></el-input>
        </el-form-item>
        <el-form-item prop="unionid_list" label="unionid" v-if="previewForm.filter_type === 'unionid_list' && previewForm.filter_type !== 'query'">
          <el-input type="textarea" :rows="4" placeholder="请输入内容" v-model="previewForm.user_list" disabled></el-input>
        </el-form-item>
        <el-form-item prop="openid_file" label="openid文件" v-if="previewForm.filter_type === 'openid_file' && previewForm.filter_type !== 'query'">
          <a :href="previewForm.user_file" class="alink" target="_blank">{{previewForm.user_file}}</a>
        </el-form-item>
        <el-form-item prop="openid_file" label="openid文件" v-if="previewForm.filter_type === 'unionid_file' && previewForm.filter_type !== 'query'">
          <a :href="previewForm.user_file" class="alink" target="_blank">{{previewForm.user_file}}</a>
        </el-form-item>
        <el-form-item prop="filter" label="筛选条件" v-if="previewForm.filter_type === 'query'">
          <div class="flex-box">
            <div v-for="(item, index) in previewForm.filter" :key="index" class="filter-box" :style="index === 0 ? ('width:calc(' + 100/chooseFilters.length + '% - 70px);float:left;flex:none;max-width:500px;') : 'max-width:600px;'">
              <user-filter-show :chooseFilters="chooseFilters" :chooseIndex="index" :filters="filters" :disabled="true"></user-filter-show>
            </div>
          </div>
        </el-form-item>
        <el-form-item prop="remark" label="备注">
          <el-input v-model.trim="previewForm.remark" disabled></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="previewHandleExit">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import VueCookie from 'vue-cookie'
import { Mp } from '@/model'
import Config from '@/conf'
export default {
  data () {
    let token = VueCookie.get(Config['token_key'])
    let authorizer = VueCookie.get(Config['current_key'])
    return {
      filterMaxLength: 5,
      uploadData: {
        token: token,
        authorizer: authorizer
      },
      tableData: [],
      total: 0,
      filter: {
        status: '',
        search: '',
        page: '1',
        limit: '10'
      },
      dialogVisible: false,
      addLoading: false,
      form: {
        name: '',
        remark: '',
        filter: ''
      },
      rules: {
        name: [
          {required: true, message: '请输入名称', trigger: 'blur'}
        ],
        remark: [
          {required: true, message: '请输入备注', trigger: 'blur'}
        ],
        filter: [
          {required: true, message: '请选择筛选条件', trigger: 'blur'}
        ]
      },
      filterLoading: false,
      filterVisible: false,
      filters: {},
      chooseFilters: [],
      currentIndex: null,
      chooseVal: {},
      chooseValStr: {},
      uploadVisible: false,
      uploadForm: {
        name: '',
        filter_type: 'openid_list',
        unionid_list: '',
        openid_list: '',
        openid_file: '',
        unionid_file: '',
        remark: ''
      },
      uploadRules: {
        name: [
          {required: true, message: '请输入名称'}
        ],
        remark: [
          {required: true, message: '请输入备注'}
        ],
        openid_list: [
          {required: true, message: '请输入openid'}
        ],
        unionid_list: [
          {required: false, message: '请输入unionid'}
        ],
        openid_file: [
          {required: false, message: '请上传openid文件'}
        ],
        unionid_file: [
          {required: false, message: '请上传unionid文件'}
        ]
      },
      filter_type: [
        'openid_list',
        'unionid_list',
        'openid_file',
        'unionid_file'
      ],
      previewVisible: false,
      previewLoading: false,
      previewForm: {
        name: '',
        filter_type: 'openid_list',
        user_file: '',
        user_list: '',
        remark: ''
      }
    }
  },
  watch: {
    '$route': function () {
      this.queryToFilter()
    },
    'uploadForm.filter_type': function (val) {
      this.filter_type.map(item => {
        if (item === val) {
          this.uploadRules[val][0]['required'] = true
        } else {
          this.uploadRules[item][0]['required'] = false
        }
      })
    },
    'chooseFilters': function (val) {
      this.form.filter = val
    }
  },
  methods: {
    previewHandleExit () {
      this.previewVisible = false
      this.chooseFilters = []
      this.previewForm = {
        name: '',
        filter_type: 'openid_list',
        user_file: '',
        user_list: '',
        remark: ''
      }
    },
    uploadHandleSubmit (refForm) {
      this.$refs[refForm].validate(async (valid) => {
        if (valid) {
          let data = {
            name: this.uploadForm.name,
            filter_type: this.uploadForm.filter_type,
            remark: this.uploadForm.remark
          }
          switch (this.uploadForm.filter_type) {
            case 'openid_list':
              // data['user_list'] = this.uploadForm.openid_list.replace(/\n/g, ',').split(',')
              data['user_list'] = this.uploadForm.openid_list.split(/\n/)
              data['user_list'] = JSON.stringify(data['user_list'])
              break
            case 'unionid_list':
              data['user_list'] = this.uploadForm.unionid_list.split(/\n/)
              break
            case 'openid_file':
              data['user_file'] = this.uploadForm.openid_file
              break
            case 'unionid_file':
              data['user_file'] = this.uploadForm.unionid_file
              break
            default:
              break
          }
          this.addLoading = true
          let res = await Mp.Custom.savePackageInfoByUpload(data)
          if (!res['err_code']) {
            this.$message.success('上传成功！')
            this.uploadHandleExit()
            this.getPackageList()
          } else {
            this.$message.success(res['err_msg'])
          }
          this.addLoading = false
        }
      })
    },
    uploadHandleExit () {
      this.uploadVisible = false
      this.uploadForm = {
        name: '',
        filter_type: 'openid_list',
        unionid_list: '',
        openid_list: '',
        openid_file: '',
        unionid_file: '',
        remark: ''
      }
    },
    handleAvatarSuccess (res, file) {
      if (!res['err_code']) {
        if (this.uploadForm.filter_type === 'openid_file') {
          this.uploadForm.openid_file = res.data.oss_url
        } else if (this.uploadForm.filter_type === 'unionid_file') {
          this.uploadForm.unionid_file = res.data.oss_url
        } else {
          this.$message.error('非openid_file或unionid_file')
        }
      } else {
        this.$message.error(res['err_msg'])
      }
    },
    beforeAvatarUpload (file) {
      const isTxt = file.type === 'text/plain'

      if (!isTxt) {
        this.$message.error('只能上传txt文件!')
      }
      return isTxt
    },
    uploadError () {
      this.$message.error('上传失败，请重新上传')
    },
    handleChangeFilter (val) {
      this.filter['page'] = 1
      this.filterHandle()
    },
    resetFilter () {
      this.filter = {
        status: '',
        search: '',
        page: '1',
        limit: '10'
      }
      this.filterHandle()
    },
    filterHandle () {
      this.$router.replace({path: '/mp/custom/package', query: this.filter})
    },
    queryToFilter () {
      let filter = JSON.parse(JSON.stringify(this.$route.query))
      for (let k in this.filter) {
        if (!filter[k]) {
          filter[k] = this.filter[k]
        }
      }
      this.filter = filter
      this.getPackageList()
    },
    handleSizeChange (val) {
      this.filter['page'] = 1
      this.filter['limit'] = val
      this.filterHandle()
    },
    handleCurrentChange (val) {
      this.filter['page'] = val
      this.filterHandle()
    },
    async getPackageList (params = {}) {
      this.loading = true
      let result = await Mp.Custom.getPackageList(this.filter)
      this.tableData = result['data']['list']
      this.total = result['data']['count']
      this.loading = false
    },
    addHandle () {
      this.chooseFilters = [{
        relation: '',
        filter: {}
      }]
      this.dialogVisible = true
    },
    async previewHandle (row) {
      this.previewVisible = true
      this.previewLoading = true
      let form = JSON.parse(JSON.stringify(row))
      if (form.filter_type === 'openid_list' || form.filter_type === 'unionid_list') {
        form.user_list = JSON.parse(form.user_list).join('\n')
      }
      if (form.filter_type === 'query') {
        form.filter = JSON.parse(form.filter)
        this.chooseFilters = form.filter
      }
      this.previewForm = form
      this.previewLoading = false
    },
    // async previewHandle (row) {
    //   this.previewVisible = true
    //   this.previewLoading = true
    //   let res = await Mp.Custom.getPackageDetail({
    //     id: row.id
    //   })
    //   if (!res['err_code']) {
    //     let form = res['data']
    //     if (form.filter_type === 'openid_list' || form.filter_type === 'unionid_list') {
    //       form.user_list = JSON.parse(form.user_list).join('\n')
    //     }
    //     this.previewForm = form
    //     if (form.filter_type === 'query') {
    //       this.chooseFilters = form.filter
    //     }
    //   } else {
    //     this.$message.error(res['err_msg'])
    //   }
    //   this.previewLoading = false
    // },
    // deleteHandle (row) {
    //   this.$confirm('此操作将删除该人群包, 是否继续?', '提示', {
    //     confirmButtonText: '确定',
    //     cancelButtonText: '取消',
    //     type: 'warning'
    //   }).then(() => {
    //     this.deleteFn(row.id)
    //   }).catch(() => {
    //     this.$message({
    //       type: 'info',
    //       message: '已取消删除'
    //     })
    //   })
    // },
    // async deleteFn (id) {
    //   let res = await Mp.custom
    // },
    handleExit () {
      this.form = {
        name: '',
        remark: '',
        filter: ''
      }
      this.chooseFilters = []
      this.dialogVisible = false
    },
    handleSubmit () {
      this.$refs['refForm'].validate(async (valid) => {
        if (valid) {
          let status = true
          this.form.filter[0]['relation'] = 'test'
          this.form.filter.map(item => {
            if (item.relation === '' || JSON.stringify(item.filter) === '{}') {
              status = false
            }
          })
          if (!status) {
            this.$message.error('不允许有空的筛选条件及计算关系!')
            return false
          }
          this.form.filter[0]['relation'] = ''
          let form = {
            name: this.form.name,
            remark: this.form.remark,
            filter: JSON.stringify(this.form.filter)
          }
          this.addLoading = true
          let res = await Mp.Custom.savePackageInfo(form)
          if (!res['err_code']) {
            this.$message.success('添加成功！')
            this.handleExit()
            this.queryToFilter()
          } else {
            this.$message.error(res['err_msg'])
          }
          this.addLoading = false
        }
      })
    },
    editFilter (index) {
      this.currentIndex = index
      this.filterVisible = true
      this.getMpFilterCriteria()
    },
    deleteFilter (index) {
      this.chooseFilters.splice(index, 1)
    },
    changeRelation (val, index) {
      this.chooseFilters[index]['relation'] = val
    },
    addFilter () {
      if (this.chooseFilters.length >= this.filterMaxLength) {
        this.$message.error(`最多只能添加${this.filterMaxLength}组！`)
      } else {
        this.chooseFilters.push({
          relation: '',
          filter: {}
        })
        this.getMpFilterCriteria()
      }
    },
    getFilterValues (val) {
      if (this.currentIndex !== null) {
        // this.chooseFilters.splice(this.currentIndex, 1, val)
        this.chooseFilters[this.currentIndex]['filter'] = val['filter']
        this.chooseFilters = JSON.parse(JSON.stringify(this.chooseFilters))
      } else {
        this.chooseFilters.push({
          relation: '',
          filter: val['filter']
        })
      }
      this.filterVisible = false
    },
    closeFilters () {
      this.filterVisible = false
    },
    async getPackageRelationSetting () {
      let res = await Mp.Custom.getPackageRelationSetting()
    },
    async getPackageStatusList () {
      let res = await Mp.Custom.getPackageStatusList()
    },
    async getMpFilterCriteria () {
      this.filterLoading = true
      let res = await Mp.Custom.getMpFilterCriteria()
      if (!res['err_code']) {
        this.filters = res['data']
        var chooseValStr = {}
        for (let key in res) {
          chooseValStr[key] = {}
          if (res[key]['child_time']) {
            chooseValStr[key]['child_time'] = []
          }
          chooseValStr[key]['filter'] = {}
          for (let k in res[key]['filter']) {
            if (res[key]['filter'][k]['html_type'] === 'input') {
              chooseValStr[key]['filter'][k] = ''
            } else {
              chooseValStr[key]['filter'][k] = []
            }
          }
        }
        this.chooseVal = chooseValStr
        this.chooseValStr = JSON.parse(JSON.stringify(chooseValStr))
      }
      this.filterNumbers++
      this.filterLoading = false
    },
    uploadPackageHandle () {
      this.uploadVisible = true
    }
  },
  created () {
    this.queryToFilter()
    this.getMpFilterCriteria()
    this.getPackageStatusList()
    this.getPackageRelationSetting()
  },
  mounted () {
  }
}
</script>

<style scoped>
</style>
